import { Grid, Typography } from '@mui/material'
import clsx from 'clsx'
import Image from 'next/image'
import React from 'react'
import useStyles from './Style'

interface IProps {
  zenMode: boolean
  content: {
    icon: string
    text: string
  }
}
const Card: React.FC<IProps> = ({ zenMode, content }) => {
  const { classes } = useStyles()
  const { icon, text } = content
  return (
    <Grid
      container
      direction="column"
      className={clsx(
        classes.rootContainer,
        zenMode && classes.zenRootContainer
      )}
    >
      <Grid
        item
        className={classes.imgContainer}
        sx={{ display: zenMode ? 'none' : 'flex' }}
      >
        <Image alt={text} src={icon} fill />
      </Grid>
      <Grid>
        <Typography className={classes.text}>{text}</Typography>
      </Grid>
    </Grid>
  )
}

export default Card
